import AccessPermits from "components/accessPermits";
import AdminAccessPermits from "components/admin/accessPermits";
import AdminTariffs from "components/admin/adminTariffs";
import BlockedEmails from "components/admin/blockedEmails";
import AdminClientStatisticsReport from "components/admin/clientStatisticsReport";
import DocumentNumberSettings from "components/admin/documentNumberSettings";
import AdminDrivers from "components/admin/drivers";
import DeviceStatistics from "components/admin/drivers/deviceStatistics";
import DriversStatsOfYearReport from "components/admin/driversStatsOfYearReport";
import EmulatedSegmentsLogs from "components/admin/emulatedSegmentsLogs";
import FeedbackTags from "components/admin/feedbackTags";
import AdminFilterCoordinates from "components/admin/filterCoordinates";
import FixRouteBids from "components/admin/fixRouteBids";
import FuelLimitsReport from "components/admin/fuelLimitsReport";
import AdminInsolvencyRegistry from "components/admin/insolvencyRegistry";
import IntegrationClients from "components/admin/integrationClients";
import MobileAppRatings from "components/admin/mobileAppRatings";
import NeuralNetworkLogs from "components/admin/neuralNetworkLogs";
import OrganizationActivityReport from "components/admin/organizationActivityReport";
import OrganizationRecommendations from "components/admin/organizationRecommendations";
import AdminOrganizations from "components/admin/organizations";
import AdminParcelStatuses from "components/admin/parcelStatuses";
import PaymentPoints from "components/admin/paymentPoints";
import AdminPlanFactOverallReport from "components/admin/planFactOverallReport";
import AdminPlatformNews from "components/admin/platformNews";
import Popups from "components/admin/popups";
import PopupTemplates from "components/admin/popupTemplates";
import PreservedTrackerLogs from "components/admin/preservedTrackerLogs";
import RegionDryingPeriods from "components/admin/regionDryingPeriods";
import ReportAllowedUsers from "components/admin/reportAllowedUsers";
import RequestStatistics from "components/admin/requestStatistics";
import SuitableOrdersReport from "components/admin/suitableOrdersReport";
import AdminTrackerLogs from "components/admin/trackerLogs";
import UnstableZones from "components/admin/unstableZones";
import AdminUsers from "components/admin/users";
import Assistant from "components/assistant";
import Bid from "components/bid";
import CalculationQueues from "components/calculationQueues";
import CarChats from "components/carChats";
import CargoOwners from "components/cargoOwners";
import CargorunIndex from "components/cargorunIndex";
import Chats from "components/chats";
import ClassificationTypes from "components/classificationTypes";
import ClientStatistics from "components/clientStatistics";
import ConnectKontur from "components/connectKontur";
import CounterpartyGroups from "components/counterpartyGroups";
import Couplings from "components/couplings";
import CustomPoints from "components/customPoints";
import Dashboard from "components/dashboard";
import Dictionaries from "components/dictionaries";
import DistributionBidSources from "components/distributionBidSources";
import DistributionBids from "components/distributionBids";
import DocumentTemplates from "components/documentTemplates";
import Drivers from "components/drivers";
import EmergencyAreaPoints from "components/emergencyAreaPoints";
import Finances from "components/finances";
import OrganizationFixRouteBids from "components/fixRouteBids";
import FuelCards from "components/fuelCards";
import HiredPark from "components/hiredPark";
import Integration from "components/integration";
import ItemChangePoints from "components/itemChangePoints";
import LegalPersons from "components/legalPersons";
import News from "components/news";
import NotificationQueues from "components/notificationQueues";
import Notifications from "components/notifications";
import OrganizationCatalogs from "components/organizationCatalogs";
import PerformancePlans from "components/performancePlans";
import { CarPlanning, CityPlanning, IntersectionsPlanning, TripPlanning } from "components/planning";
import UserPlatformNews from "components/platformNews";
import PlatonPoints from "components/platonPoints";
import PostamatPoints from "components/postamatPoints";
import RegionGroups from "components/regionGroups";
import Reports from "components/reports";
import RouteControlPoints from "components/routeControlPoints";
import RouteTemplates from "components/routeTemplates";
import Scenarios from "components/scenarios";
import ShippingOrders from "components/shippingOrders";
import SystemCatalogs from "components/systemCatalogs";
import Tasks from "components/tasks";
import Trackers from "components/trackers";
import TrackersInfo from "components/trackersInfo";
import Trailers from "components/trailers";
import TransportColumns from "components/transportColumns";
import TripScenarios from "components/tripScenarios";
import Trucks from "components/trucks";
import UserLogs from "components/userLogs";
import UsersGroups from "components/usersGroups";
import UsersGroupsCars from "components/usersGroupsCars";
import Waybills from "components/waybills";
import Profile from "containers/profile";
import { forwardingUrl } from "helpers/forwarding";
import { RolesModel } from "helpers/roles";
import policy from "policies";
import React, { FC } from "react";
import { ConnectedComponent } from "react-redux";
import { featureModuleTypesEnum } from "./enums";

type RouteID = string | number;

const paths = {
    mobileApps: (tab: string) => `/mobile-apps?tab=${tab}`,

    forwarding: forwardingUrl(),
    forwardingLogin: `${forwardingUrl()}/cargorunAuth`,
    forwardingAuth: `/authorization/expedition`,
    forwardingOrganizationLogo: (organizationId: RouteID) =>
        `${forwardingUrl()}/api/Organization/GetLogo?organizationId=${organizationId}`,
    forwardingTruckerPlanning: `${forwardingUrl()}/truckerPlanning`,
    forwardingSuitableOrder: `/suitable-orders/forwarding`,

    domain: "/",
    root: "/monitoring",
    login: "/login",
    registration: "/registration",
    registrationAtiSu: "/registration/atisu",
    registrationCallbackAtiSu: "/registration/callback/atisu",
    registrationCreateRelay: "/registration/create-relay",
    registrationAddCars: "/registration/add-cars",
    registrationAddDrivers: "/registration/add-drivers",
    registrationAddTrucks: "/registration/add-trucks",
    forgotPassword: "/account/forgotPassword",
    resetPassword: "/account/resetPassword",
    confirmEmail: "/account/confirmEmail",
    acceptInvitation: "/account/acceptInvitation",
    unsubscribe: "/notifications/unsubscribe",
    licenseExpired: "/license-expired",

    home: "/home",
    error: "/home/error",
    ip: "/home/ip",
    headers: "/home/headers",
    ping: "/home/ping",

    connectKontur: "/organization/connect-kontur",

    dashboard: "/dashboard",
    cargorunIndex: "/ftl-index",
    assistant: "/assistant",

    bid: "/bids",
    bidNew: "/bids/new",
    bidShow: (type: "bid" | "distributionBid", id: RouteID) => `/bids/${type}/${id}`,
    bidEdit: (id: RouteID) => `/bids/edit/${id}`,

    epd: "/epd",
    shippingOrders: "/epd/shipping-orders",
    shippingOrdersShow: (id: RouteID) => `/epd/shipping-orders/${id}`,
    waybills: "/epd/waybills",
    waybillsShow: (id: RouteID) => `/epd/waybills/${id}`,

    chats: "/chats",
    chatsShow: (id: RouteID) => `/chats/list/${id}`,

    carChats: "/car-chats",
    carChatsShow: (id: RouteID) => `/car-chats/${id}`,

    notifications: "/notifications",
    notificationsShow: (id: RouteID) => `/notifications/list/${id}`,

    drivers: "/drivers",
    driversNew: "/drivers/new",
    driversShow: (id: RouteID) => `/drivers/list/${id}`,

    distributionBids: "/distribution-bids",
    distributionBidsNew: "/distribution-bids/list/new",
    distributionBidShow: (id: RouteID) => `/distribution-bids/bid/${id}`,
    distributionBidEdit: (id: RouteID) => `/distribution-bids/edit/${id}`,

    trailers: "/trailers",
    trailersNew: "/trailers/new",
    trailersShow: (id: RouteID) => `/trailers/list/${id}`,

    transportColumns: "/transport-columns",
    transportColumnsNew: "/transport-columns/new",
    transportColumnsShow: (id: RouteID) => `/transport-columns/list/${id}`,

    counterpartyGroups: "/counterparty-groups",
    counterpartyGroupsNew: "/counterparty-groups/new",
    counterpartyGroupsShow: (id: RouteID) => `/counterparty-groups/list/${id}`,

    trucks: "/trucks",
    trucksNew: "/trucks/new",
    trucksShow: (id: RouteID) => `/trucks/list/${id}`,
    trucksAddLogist: "/trucks/add-logist",

    // Hired park
    hiredPark: "/hired-park",
    hiredCars: "/hired-park/cars",
    hiredCarsNew: "/hired-park/cars/new",
    hiredCarsEdit: (id: RouteID) => `/hired-park/cars/${id}/edit`,
    hiredCarsShow: (id: RouteID) => `/hired-park/cars/${id}`,

    hiredTrailers: "/hired-park/trailers",
    hiredTrailersNew: "/hired-park/trailers/new",
    hiredTrailersEdit: (id: RouteID) => `/hired-park/trailers/${id}/edit`,
    hiredTrailersShow: (id: RouteID) => `/hired-park/trailers/${id}`,

    hiredDrivers: "/hired-park/drivers",
    hiredDriversNew: "/hired-park/drivers/new",
    hiredDriversEdit: (id: RouteID) => `/hired-park/drivers/${id}/edit`,
    hiredDriversShow: (id: RouteID) => `/hired-park/drivers/${id}`,

    calculationQueues: "/admin/calculation-queues",
    calculationQueuesNew: "/admin/calculation-queues/list/new",

    cargoOwners: "/cargo-owners",
    cargoOwnersNew: "/cargo-owners/new",
    cargoOwnersShow: (id: RouteID) => `/cargo-owners/${id}`,

    counterpartyPoints: (counterpartyId: RouteID) => `/cargo-owners/${counterpartyId}/points`,
    counterpartyPointsNew: (counterpartyId: RouteID) => `/cargo-owners/${counterpartyId}/points/new`,
    counterpartyPointShow: (counterpartyId: RouteID, id: RouteID) => `/cargo-owners/${counterpartyId}/points/${id}`,

    counterpartyContracts: (counterpartyId: RouteID) => `/cargo-owners/${counterpartyId}/contracts`,
    counterpartyContractsNew: (counterpartyId: RouteID) => `/cargo-owners/${counterpartyId}/contracts/new`,
    counterpartyContractsShow: (counterpartyId: RouteID, id: RouteID) =>
        `/cargo-owners/${counterpartyId}/contracts/${id}`,

    dictionaries: "/dictionaries",
    dictionariesShow: (id: RouteID) => `/dictionaries/list/${id}`,

    trackers: "/trackers",
    trackersNew: "/trackers/new",
    trackersShow: (id: RouteID) => `/trackers/list/${id}`,

    trackerHistory: (trackerId: RouteID) => `/trackers/list/${trackerId}/history`,
    trackerHistoryNew: (trackerId: RouteID) => `/trackers/list/${trackerId}/history/new`,
    trackerHistoryItem: (trackerId: RouteID, id: RouteID) => `/trackers/list/${trackerId}/history/${id}`,

    trackerOdometerValues: (trackerId: RouteID) => `/trackers/list/${trackerId}/odometer-values`,

    logistHistory: (truckId: RouteID) => `/trucks/list/${truckId}/history`,
    logistHistoryNew: (truckId: RouteID) => `/trucks/list/${truckId}/history/new`,
    logistHistoryItem: (truckId: RouteID, id: RouteID) => `/trucks/list/${truckId}/history/${id}`,

    customPoints: "/custom-points",
    customPointsNew: "/custom-points/new",
    customPointsShow: (id: RouteID) => `/custom-points/list/${id}`,

    itemChangePoints: "/item-change-points",
    itemChangePointsShow: (id: RouteID) => `/item-change-points/${id}`,

    regionGroups: "/region-groups",
    regionGroupsNew: "/region-groups/new",
    regionGroupsShow: (id: RouteID) => `/region-groups/list/${id}`,

    reports: "/reports",
    reportsShow: (id: RouteID) => `/reports/${id}`,

    planning: "/planning",
    planningShow: (id: RouteID) => `/planning/${id}`,

    performancePlans: "/performance-plans",
    performancePlansHistory: "/performance-plans/history",
    performancePlansSettings: "/performance-plans/settings",

    profile: "/profile",
    profileAccess: "/profile/access",
    profileAccessMembers: "/profile/access/members",
    profileAccessBlock: "/profile/access/blocked",
    profileAccessInvited: "/profile/access/invited",
    profileOrgData: "/profile/organization",
    profileEpdSettings: "/profile/epd-settings",
    profileConnectCars: "/profile/connect-cars",
    profileEntityOptions: "/profile/entityOptions",
    profileUserData: "/profile/profile",
    profileAccount: "/profile/account",
    profileEducationResources: "/profile/education-resources",
    profileTaskSettings: "/profile/task-settings",
    profileBilling: "/profile/billing",
    profileBillingDocuments: "/profile/billing/documents",
    profileBillingDocumentDownload: (id: RouteID) => `/profile/billing/documents/${id}/download`,
    profileBillingCharges: "/profile/billing/charges",
    profileBillingPayments: "/profile/billing/payments",
    profileBillingNotifications: "/profile/billing/notifications",

    adminUsers: "/admin/users",
    userLogs: "/admin/user-logs",
    userLogsShow: (id: RouteID) => `/admin/user-logs/list/${id}`,

    adminTrackerLogs: "/admin/tracker-logs",

    adminFilterCoordinates: "/admin/filter-coordinates",

    adminDrivers: "/admin/drivers",
    adminDriverDeviceStatistics: "/admin/driver-device-statistics",

    adminOrganizations: "/admin/organizations",
    adminOrganizationsNew: "/admin/organizations/new",
    adminOrganizationsShow: (id: RouteID) => `/admin/organizations/list/${id}`,
    adminOrganizationModules: (id: RouteID) => `/admin/organizations/list/${id}/feature-modules`,
    adminOrganizationOdometerHistory: (id: RouteID) => `/admin/organizations/list/${id}/odometer-history`,
    adminOrganizationSettings: "/admin/organizations/settings",

    integrationClients: "/admin/integration-clients",
    integrationClientsNew: "/admin/integration-clients/new",
    integrationClient: (clientId: RouteID) => `/admin/integration-clients/${clientId}`,

    routeTemplates: "/route-templates",
    routeTemplatesShow: (id: RouteID) => `/route-templates/list/${id}`,

    emergencyAreaPoints: "/emergency-area-points",
    emergencyAreaPointsShow: (id: RouteID) => `/emergency-area-points/list/${id}`,
    emergencyAreaPointsNew: `/emergency-area-points/new`,

    routeControlPoints: "/route-control-points",
    routeControlPointsShow: (id: RouteID) => `/route-control-points/list/${id}`,
    routeControlPointsNew: `/route-control-points/new`,

    organizationCatalogs: "/organization-catalogs",
    organizationCatalogsShow: (id: RouteID) => `/organization-catalogs/list/${id}`,
    organizationCatalogItems: (id: RouteID) => `/organization-catalogs/list/${id}/items`,

    systemCatalogs: "/system-catalogs",
    systemCatalogsShow: (id: RouteID) => `/system-catalogs/list/${id}`,

    scenarios: "/scenarios",
    scenariosNew: "/scenarios/new",
    scenariosShow: (id: RouteID) => `/scenarios/list/${id}`,

    tripScenarios: "/trip-scenarios",
    tripScenariosNew: "/trip-scenarios/new",
    tripScenariosShow: (id: RouteID) => `/trip-scenarios/list/${id}`,

    trackersInfo: "/admin/trackers-info",

    couplings: "/couplings",

    usersGroups: "/users-groups",
    usersGroupsShow: (id: RouteID) => `/users-groups/${id}`,
    usersGroupCars: (groupId: RouteID) => `/users-groups/${groupId}/cars`,
    usersGroupUsers: (groupId: RouteID) => `/users-groups/${groupId}/users`,

    usersGroupsCars: "/users-groups-cars",

    news: "/news",
    newsNew: "/news/new",
    newsShow: (id: RouteID) => `/news/list/${id}`,

    postamatPoints: "/postamat-points",
    postamatPointsNew: "/postamat-points/new",
    postamatPointsShow: (id: RouteID) => `/postamat-points/${id}`,

    notificationQueues: "/admin/notification-queues",
    notificationQueueShow: (id: RouteID) => `/admin/notification-queues/list/${id}`,

    clientStatistics: "/admin/client-statistics",

    blockedEmails: "/admin/blocked-emails",

    distributionBidSources: "/distribution-bid-sources",

    fuelCards: "/fuel-cards",
    fuelCardsShow: (id: RouteID) => `/fuel-cards/list/${id}`,

    organizationActivityReport: "/admin/organization-activity-report",
    driversStatsOfYearReport: "/admin/driver-stats-of-year-report",
    fuelLimitsReport: "/admin/fuel-limits-report",
    suitableOrdersReport: "/admin/suitable-orders-report",

    requestStatistics: "/admin/request-statistics",

    fixRouteBids: "/admin/fix-route-bids",
    fixRouteBidsShow: (id: RouteID) => `/admin/fix-route-bids/list/${id}`,

    organizationFixRouteBids: "/fix-route-bids",
    organizationFixRouteBidsShow: (id: RouteID) => `/fix-route-bids/list/${id}`,

    neuralNetworkLogs: "/admin/neural-network-logs",

    organizationRecommendations: "/admin/organization-recommendations",

    mobileAppRatings: "/admin/mobile-app-ratings",

    organizationRatings: "/organization-ratings",
    assistantChatReport: (reportType: string, messageId: string) => `/assistantChat/report/${reportType}/${messageId}`,

    tasks: "/tasks",
    tasksKanban: "/tasks/kanban",
    tasksTable: "/tasks/table",
    tasksShow: (id: RouteID) => `/tasks/${id}`,

    legalPersons: "/legal-persons",
    legalPersonsNew: "/legal-persons/new",
    legalPersonsShow: (id: RouteID) => `/legal-persons/${id}`,

    popups: "/admin/popups",
    popupsShow: (id: RouteID) => `/admin/popups/list/${id}`,

    popupTemplates: "/admin/popup-templates",
    popupTemplatesShow: (id: RouteID) => `/admin/popup-templates/list/${id}`,

    platonPoints: "/platon-points",
    platonPointsNew: "/platon-points/new",
    platonPointsShow: (id: RouteID) => `/platon-points/list/${id}`,

    accessPermits: "/access-permits",
    adminAccessPermits: "/admin/access-permits",
    adminAccessPermitsNew: "/admin/access-permits/new",
    adminAccessPermitsShow: (id: RouteID) => `/admin/access-permits/list/${id}`,

    adminParcelStatuses: "/admin/parcel-statuses",
    adminParcelStatusesNew: "/admin/parcel-statuses/new",
    adminParcelStatusesShow: (id: RouteID) => `/admin/parcel-statuses/list/${id}`,

    adminPlatformNews: "/admin/platform-news",
    adminPlatformNewsNew: "/admin/platform-news/new",
    adminPlatformNewsShow: (id: RouteID) => `/admin/platform-news/list/${id}`,

    userPlatformNews: "/platform-news",
    userPlatformNewsShow: (id: RouteID) => `/platform-news/list/${id}`,

    paymentPoints: "/admin/payment-points",
    paymentPointsShow: (id: RouteID) => `/admin/payment-points/list/${id}`,
    paymentPointsNew: `/admin/payment-points/new`,

    regionDryingPeriods: "/admin/region-drying-periods",
    regionDryingPeriodsShow: (id: RouteID) => `/admin/region-drying-periods/list/${id}`,
    regionDryingPeriodsNew: `/admin/region-drying-periods/new`,

    emulatedSegmentsLogs: "/admin/emulated-segments-logs",
    preservedTrackerLogs: "/admin/preserved-tracker-logs",
    feedbackTags: "/admin/feedback-tags",

    unstableZones: "/admin/unstable-zones",

    integration: "/integration",
    integrationItem: (id: RouteID) => `/integration/${id}`,

    tripSheets: "/finances/trip-sheets",
    tripSheetsNew: "/finances/trip-sheets/new",
    tripSheetsShow: (id: RouteID) => `/finances/trip-sheets/${id}`,
    tripSheetsChangelog: (id: RouteID) => `/finances/trip-sheets/${id}/changelog`,

    finances: "/finances",
    financesShow: (id: RouteID) => `/finances/${id}`,
    financesInvoice: "/finances/invoice",
    financesContract: "/finances/contract",
    financesAcceptanceCertificate: "/finances/acceptance-certificate",
    financesAcceptanceCertificateInvoice: "/finances/acceptance-certificate-invoice",
    financesDocumentsShow: (id: RouteID) => `/finances/documents/${id}`,
    universalTransferDocuments: "/finances/universal-transfer-documents",
    universalTransferDocumentsShow: (id: RouteID) => `/finances/universal-transfer-documents/${id}`,
    registries: "/finances/registries",
    registriesShow: (id: RouteID) => `/finances/registries/${id}`,
    documentTracking: "/finances/document-tracking",

    documentTemplates: "/document-templates",
    documentTemplatesNew: "/document-templates/new",
    documentTemplatesShow: (id: RouteID) => `/document-templates/${id}`,
    documentNumberSettings: "/document-number-settings",

    classificationTypes: "/classification-types",
    classificationTypesNew: "/classification-types/new",
    classificationTypesShow: (id: RouteID) => `/classification-types/${id}`,

    expenses: "/finances/expenses",
    expensesShow: (id: RouteID) => `/finances/expenses/${id}`,

    adminTariffs: "/admin/tariffs",
    adminReportAllowedUsers: "/admin/report-allowed-users",
    adminClientStatisticsReport: "/admin/client-statistics-report",
    adminPlanFactOverallReport: "/admin/plan-fact-overall-report",
    adminInsolvencyRegistry: "/admin/insolvency-registry",
};

type PathsKeys = keyof typeof paths;
type PathsValues = (typeof paths)[PathsKeys];

type RouteObj = {
    path: PathsValues;
    title?: ((k: (keyof typeof featureModuleTypesEnum)[]) => string) | string;
    allow: boolean;
    Component?: ConnectedComponent<any, Omit<unknown, never>> | React.ComponentType | FC;
    items?: Array<RouteObj>;
    iconClassName?: string;
    external?: boolean;
    inAdminSection?: boolean;
};

function generateRoutesObj(
    roles: RolesModel | undefined,
    currentUser: {
        availableFeatureModules: (keyof typeof featureModuleTypesEnum)[];
        isFuelLimitEnabled: boolean;
        limitedFunctionality?: boolean;
        isDemoPeriodExpired?: boolean;
        refuelingSettings?: { hideRefuelingPlanning: boolean };
        allowedReports?: Array<string>;
    },
): Array<RouteObj> {
    if (!roles) {
        roles = {} as RolesModel;
    }
    const {
        availableFeatureModules,
        isFuelLimitEnabled,
        limitedFunctionality,
        refuelingSettings,
        allowedReports,
        isDemoPeriodExpired,
    } = currentUser || {
        availableFeatureModules: [],
        isFuelLimitEnabled: false,
        limitedFunctionality: false,
        isDemoPeriodExpired: false,
        refuelingSettings: {},
        allowedReports: [],
    };
    const pathPolicy = policy("path", {
        user: { roles, allowedReports },
        record: {},
        options: {
            availableFeatureModules,
            isFuelLimitEnabled,
            limitedFunctionality,
            refuelingSettings,
        },
    });

    const result: Array<RouteObj> = [
        {
            path: paths.connectKontur,
            allow: pathPolicy.canSeeConnectKontur(),
            Component: ConnectKontur,
        },
        {
            path: paths.distributionBidSources,
            allow: pathPolicy.canSeeDistributionBidSources(),
            Component: DistributionBidSources,
        },
        {
            path: paths.counterpartyGroups,
            allow: pathPolicy.canSeeCargoOwners(),
            Component: CounterpartyGroups,
        },
        {
            path: paths.usersGroupsCars,
            allow: pathPolicy.canSeeUsersGroups(),
            Component: UsersGroupsCars,
        },
        {
            path: paths.legalPersons,
            allow: pathPolicy.canSeeLegalPersons(),
            Component: LegalPersons,
        },
        {
            path: paths.userPlatformNews,
            allow: pathPolicy.canSeeUserPlatformNews(),
            Component: UserPlatformNews,
        },
        {
            path: paths.profile,
            allow: pathPolicy.canSeeProfile(),
            Component: Profile,
        },
        {
            path: paths.itemChangePoints,
            allow: pathPolicy.canSeeItemChangePoints(),
            Component: ItemChangePoints,
        },
        {
            path: paths.dashboard,
            title: "Дашборд",
            allow: pathPolicy.canSeeDashboard(),
            Component: Dashboard,
        },
        {
            path: paths.cargorunIndex,
            title: "Индекс",
            allow: pathPolicy.canSeeCargorunIndex(),
            Component: CargorunIndex,
        },
        {
            path: paths.assistant,
            title: "Ассистент",
            allow: pathPolicy.canSeeAssistant(),
            Component: Assistant,
        },
        {
            path: paths.root,
            title: "Мониторинг",
            iconClassName: "monitoring",
            allow: true,
        },
        {
            path: paths.bid,
            title: "Заявки",
            allow: pathPolicy.canSeeBids(),
            Component: Bid,
        },
        {
            path: paths.epd,
            title: "ЭПД",
            iconClassName: "epd",
            allow: pathPolicy.canSeeWaybills(),
            items: [
                {
                    path: paths.shippingOrders,
                    title: "Заявки (ЭЗЗ)",
                    allow: pathPolicy.canSeeWaybills(),
                    Component: ShippingOrders,
                },
                {
                    path: paths.waybills,
                    title: "Накладные (ЭТрН)",
                    allow: pathPolicy.canSeeWaybills(),
                    Component: Waybills,
                },
            ],
        },
        {
            path: paths.distributionBids,
            title: "Заказы",
            allow: pathPolicy.canSeeDistributionBids(),
            Component: DistributionBids,
        },
        {
            path: paths.tasks,
            title: "Задачи",
            allow: pathPolicy.canSeeTasks(),
            Component: Tasks,
        },
        {
            path: paths.notifications,
            title: "Уведомления",
            allow: pathPolicy.canSeeChats(),
            Component: Notifications,
        },
        {
            path: "chats",
            title: "Чаты",
            allow: pathPolicy.canSeeChats(),
            iconClassName: "chats",
            items: [
                {
                    path: paths.chats,
                    title: "Чаты с водителями",
                    allow: pathPolicy.canSeeChats(),
                    Component: Chats,
                },
                {
                    path: paths.carChats,
                    title: "Чаты по грузовикам",
                    allow: pathPolicy.canSeeChats(),
                    Component: CarChats,
                },
            ],
        },
        {
            path: "planning",
            title: "Планирование",
            allow: pathPolicy.canSeePlanning(),
            iconClassName: "planning",
            items: [
                {
                    path: paths.planningShow("city-planning"),
                    title: "По городам",
                    allow: true,
                    Component: CityPlanning,
                },
                {
                    path: paths.planningShow("car-planning"),
                    title: "По машинам",
                    allow: true,
                    Component: CarPlanning,
                },
                {
                    path: paths.planningShow("trip-planning"),
                    title: "АРМ логиста",
                    allow: true,
                    Component: TripPlanning,
                },
                {
                    path: paths.planningShow("intersections-planning"),
                    title: "Поиск предстоящего проезда через геозоны",
                    allow: pathPolicy.canSeeIntersections(),
                    Component: IntersectionsPlanning,
                },
            ],
        },
        {
            path: paths.performancePlans,
            title: "Планы по пробегу и выручке",
            allow: false,
            // allow: pathPolicy.canSeePerformancePlans(),
            iconClassName: "reports",
            Component: PerformancePlans,
        },
        {
            path: paths.forwardingLogin,
            title: (availableFeatureModules: (keyof typeof featureModuleTypesEnum)[]) =>
                availableFeatureModules?.includes(featureModuleTypesEnum.CrStart as keyof typeof featureModuleTypesEnum)
                    ? "Доступные заказы"
                    : "Загрузки",
            allow: pathPolicy.canSeeForwarding(),
            iconClassName: "forwarding",
            external: true,
        },
        {
            path: paths.forwardingTruckerPlanning,
            title: "Доступный транспорт",
            allow: pathPolicy.canSeeForwarding(),
            iconClassName: "trucks",
            external: true,
        },
        {
            path: paths.reports,
            title: "Отчеты",
            allow: pathPolicy.canSeeReports(),
            Component: Reports,
        },
        {
            path: paths.finances,
            title: "Финансы и учет",
            allow: pathPolicy.canSeeFinances(),
            Component: Finances,
        },
        {
            title: "Справочники",
            allow: true,
            iconClassName: "list-ul",
            path: "dictionaries",
            items: [
                {
                    path: paths.trucks,
                    title: "Грузовики",
                    allow: pathPolicy.canSeeTrucks(),
                    Component: Trucks,
                },
                {
                    path: paths.drivers,
                    title: "Водители",
                    allow: pathPolicy.canSeeDrivers(),
                    Component: Drivers,
                },
                {
                    path: paths.trailers,
                    title: "Прицепы",
                    allow: pathPolicy.canSeeTrailers(),
                    Component: Trailers,
                },
                {
                    path: paths.hiredPark,
                    title: "Наёмный парк",
                    allow: pathPolicy.canSeeHiredPark(),
                    Component: HiredPark,
                },
                {
                    path: paths.couplings,
                    title: "Смены",
                    allow: pathPolicy.canSeeCouplings(),
                    Component: Couplings,
                },
                {
                    path: paths.usersGroups,
                    title: "Группы пользователей",
                    allow: pathPolicy.canSeeUsersGroups(),
                    Component: UsersGroups,
                },
                {
                    path: paths.transportColumns,
                    title: "Колонны",
                    allow: pathPolicy.canSeeTransportColumns(),
                    Component: TransportColumns,
                },
                {
                    path: paths.cargoOwners,
                    title: "Контрагенты",
                    allow: pathPolicy.canSeeCargoOwners(),
                    Component: CargoOwners,
                },
                {
                    path: paths.customPoints,
                    title: "Типы точек",
                    allow: pathPolicy.canSeeCustomPoints(),
                    Component: CustomPoints,
                },
                {
                    path: paths.regionGroups,
                    title: "Группы регионов",
                    allow: pathPolicy.canSeeRegionGroups(),
                    Component: RegionGroups,
                },
                {
                    path: paths.fuelCards,
                    title: "Топливные карты",
                    allow: pathPolicy.canSeeFuelCards(),
                    Component: FuelCards,
                },
                {
                    path: paths.organizationCatalogs,
                    title: "Справочники компании",
                    allow: pathPolicy.canSeeOrganizationCatalogs(),
                    Component: OrganizationCatalogs,
                },
                {
                    path: paths.systemCatalogs,
                    title: "Системные справочники",
                    allow: pathPolicy.canSeeOrganizationCatalogs(),
                    Component: SystemCatalogs,
                },
                {
                    path: paths.accessPermits,
                    title: "Допуски и разрешения",
                    allow: pathPolicy.canSeeAccessPermits(),
                    Component: AccessPermits,
                },
                {
                    path: paths.postamatPoints,
                    title: "Постаматы",
                    allow: pathPolicy.canSeePostamatPoints(),
                    Component: PostamatPoints,
                },
            ],
        },
        {
            title: "Администрирование",
            allow: pathPolicy.canSeeSettings(),
            iconClassName: "settings",
            path: "settings",
            items: [
                {
                    path: paths.integration,
                    title: "Интеграция",
                    allow: pathPolicy.canSeeIntegration(),
                    Component: Integration,
                },
                {
                    path: paths.trackers,
                    title: "Трекеры",
                    allow: pathPolicy.canSeeTrackers(),
                    Component: Trackers,
                },
                {
                    path: paths.scenarios,
                    title: "Опросы по точкам",
                    allow: pathPolicy.canSeeScenarios(),
                    Component: Scenarios,
                },
                {
                    path: paths.tripScenarios,
                    title: "Опросы в рейсе",
                    allow: pathPolicy.canSeeTripScenarios(),
                    Component: TripScenarios,
                },
                {
                    path: paths.routeTemplates,
                    title: "Шаблоны маршрутов",
                    allow: pathPolicy.canSeeRouteTemplates(),
                    Component: RouteTemplates,
                },
                {
                    path: paths.organizationFixRouteBids,
                    title: "Заявки на корректировку",
                    allow: pathPolicy.canSeeOrganizationFixRouteBids(),
                    Component: OrganizationFixRouteBids,
                },
                {
                    path: paths.platonPoints,
                    title: "Рамки Платон",
                    allow: pathPolicy.canSeePlatonPoints(),
                    Component: PlatonPoints,
                },
                {
                    path: paths.emergencyAreaPoints,
                    title: "Аварийные участки",
                    allow: pathPolicy.canSeeEmergencyAreaPoints(),
                    Component: EmergencyAreaPoints,
                },
                {
                    path: paths.routeControlPoints,
                    title: "Точки для контроля маршрута",
                    allow: pathPolicy.canSeeRouteControlPoints(),
                    Component: RouteControlPoints,
                },
                {
                    path: paths.news,
                    title: "Рассылки водителям",
                    allow: pathPolicy.canSeeNews(),
                    Component: News,
                },
                {
                    path: paths.documentTemplates,
                    title: "Шаблоны документов",
                    allow: pathPolicy.canSeeCrStart(),
                    Component: DocumentTemplates,
                },
                {
                    path: paths.documentNumberSettings,
                    title: "Настройка нумерации",
                    allow: pathPolicy.canSeeDocumentNumberSettings(),
                    Component: DocumentNumberSettings,
                },
                {
                    path: paths.classificationTypes,
                    title: "Типы номенклатур",
                    allow: pathPolicy.canSeeCrStart(),
                    Component: ClassificationTypes,
                },
            ],
        },
        {
            path: paths.dictionaries,
            allow: pathPolicy.canSeeDictionaries(),
            Component: Dictionaries,
            inAdminSection: true,
        },
        {
            title: "Интеграции",
            allow: pathPolicy.canSeeIntegrationClients(),
            iconClassName: "integration",
            path: "admin-integrations",
            inAdminSection: true,
            items: [
                {
                    path: paths.integrationClients,
                    title: "Интеграционные клиенты",
                    allow: pathPolicy.canSeeIntegrationClients(),
                    Component: IntegrationClients,
                },
            ],
        },
        {
            title: "Отчеты",
            allow: true,
            iconClassName: "reports",
            path: "admin-reports",
            inAdminSection: true,
            items: [
                {
                    path: paths.clientStatistics,
                    title: "Статистика по клиентам",
                    allow: pathPolicy.canSeeClientStatistics(),
                    Component: ClientStatistics,
                },
                {
                    path: paths.organizationActivityReport,
                    title: "Вовлеченность пользователей",
                    allow: pathPolicy.canSeeOrganizationActivityReport(),
                    Component: OrganizationActivityReport,
                },
                {
                    path: paths.driversStatsOfYearReport,
                    title: "Статистика водителей за год",
                    allow: pathPolicy.canSeeDriversStatsOfYearReport(),
                    Component: DriversStatsOfYearReport,
                },
                {
                    path: paths.fuelLimitsReport,
                    title: "Отчет по автооткрытию лимитов по топливным картам",
                    allow: pathPolicy.canSeeFuelLimitsReport(),
                    Component: FuelLimitsReport,
                },
                {
                    path: paths.requestStatistics,
                    title: "Статистика запросов",
                    allow: pathPolicy.canSeeRequestStatistics(),
                    Component: RequestStatistics,
                },
                {
                    path: paths.suitableOrdersReport,
                    title: "Отчет по подбору подходящих заказов",
                    allow: pathPolicy.canSeeSuitableOrdersReport(),
                    Component: SuitableOrdersReport,
                },
                {
                    path: paths.adminClientStatisticsReport,
                    title: "Отчет по динамике показателей клиентов",
                    allow: pathPolicy.canSeeAdminClientStatisticsReport(),
                    Component: AdminClientStatisticsReport,
                },
                {
                    path: paths.adminPlanFactOverallReport,
                    title: "Отчет сравнения пробегов по всем компаниям",
                    allow: pathPolicy.canSeeAdminPlanFactOverallReport(),
                    Component: AdminPlanFactOverallReport,
                },
            ],
        },
        {
            title: "Логи",
            allow: true,
            iconClassName: "user-logs",
            path: "logs",
            inAdminSection: true,
            items: [
                {
                    path: paths.notificationQueues,
                    title: "Логи уведомлений",
                    allow: pathPolicy.canSeeNotificationQueues(),
                    Component: NotificationQueues,
                },
                {
                    path: paths.userLogs,
                    title: "Логи запросов",
                    allow: pathPolicy.canSeeUserLogs(),
                    Component: UserLogs,
                },
                {
                    path: paths.neuralNetworkLogs,
                    title: "Логи нейронной сети",
                    allow: pathPolicy.canSeeNeuralNetworkLogs(),
                    Component: NeuralNetworkLogs,
                },
                {
                    path: paths.emulatedSegmentsLogs,
                    title: "Логи эмуляции координат",
                    allow: pathPolicy.canSeeEmulatedSegmentsLogs(),
                    Component: EmulatedSegmentsLogs,
                },
                {
                    path: paths.preservedTrackerLogs,
                    title: "Логи фильтрации координат",
                    allow: pathPolicy.canSeePreservedTrackerLogs(),
                    Component: PreservedTrackerLogs,
                },
            ],
        },
        {
            path: paths.mobileAppRatings,
            title: "Оценки приложения",
            allow: pathPolicy.canSeeMobileAppRatings(),
            Component: MobileAppRatings,
            inAdminSection: true,
        },
        {
            path: paths.calculationQueues,
            title: "Перерасчет",
            allow: pathPolicy.canSeeCalculationQueues(),
            Component: CalculationQueues,
            inAdminSection: true,
        },
        {
            path: paths.adminUsers,
            title: "Пользователи",
            allow: pathPolicy.canSeeAdminUsers(),
            Component: AdminUsers,
            inAdminSection: true,
        },
        {
            path: paths.adminDrivers,
            title: "Все водители",
            allow: pathPolicy.canSeeAdminDrivers(),
            Component: AdminDrivers,
            inAdminSection: true,
        },
        {
            path: paths.adminDriverDeviceStatistics,
            allow: pathPolicy.canSeeAdminDrivers(),
            Component: DeviceStatistics,
            inAdminSection: true,
        },
        {
            path: paths.adminTrackerLogs,
            title: "Трекер логи",
            allow: pathPolicy.canSeeAdminTrackerLogs(),
            Component: AdminTrackerLogs,
            inAdminSection: true,
        },
        {
            path: paths.adminFilterCoordinates,
            title: "Фильтрация координат",
            allow: pathPolicy.canSeeAdminFilterCoordinates(),
            Component: AdminFilterCoordinates,
            inAdminSection: true,
        },
        {
            path: paths.adminOrganizations,
            title: "Все организации",
            allow: pathPolicy.canSeeAdminOrgs(),
            Component: AdminOrganizations,
            inAdminSection: true,
        },
        {
            path: paths.trackersInfo,
            title: "Координаты",
            allow: pathPolicy.canSeeTrackersInfo(),
            Component: TrackersInfo,
            inAdminSection: true,
        },
        {
            path: paths.blockedEmails,
            title: "Заблокированные эл.адреса",
            allow: pathPolicy.canSeeBlockedEmails(),
            Component: BlockedEmails,
            inAdminSection: true,
        },
        {
            path: paths.fixRouteBids,
            title: "Заявки на корректировку",
            allow: pathPolicy.canSeeFixRouteBids(),
            Component: FixRouteBids,
            inAdminSection: true,
        },
        {
            path: paths.organizationRecommendations,
            title: "Рекомендации",
            allow: pathPolicy.canSeeOrganizationRecommendations(),
            Component: OrganizationRecommendations,
            inAdminSection: true,
        },
        {
            title: "Pop-up уведомления",
            allow: pathPolicy.canSeePopups(),
            iconClassName: "popups",
            path: "popups",
            inAdminSection: true,
            items: [
                {
                    path: paths.popups,
                    title: "Список уведомлений",
                    allow: pathPolicy.canSeePopups(),
                    Component: Popups,
                },
                {
                    path: paths.popupTemplates,
                    title: "Шаблоны уведомлений",
                    allow: pathPolicy.canSeePopups(),
                    Component: PopupTemplates,
                },
            ],
        },
        {
            path: paths.adminPlatformNews,
            title: "Информирование пользователей",
            allow: pathPolicy.canSeeAdminPlatformNews(),
            Component: AdminPlatformNews,
            inAdminSection: true,
        },
        {
            path: paths.paymentPoints,
            title: "Пункты оплаты",
            allow: pathPolicy.canSeePaymentPoints(),
            Component: PaymentPoints,
            inAdminSection: true,
        },
        {
            path: paths.adminTariffs,
            title: "Тарифы",
            allow: pathPolicy.canSeeAdminTariffs(),
            Component: AdminTariffs,
            inAdminSection: true,
        },
        {
            path: paths.feedbackTags,
            title: "Теги оценок",
            allow: pathPolicy.canSeeFeedbackTags(),
            Component: FeedbackTags,
            inAdminSection: true,
        },
        {
            path: paths.unstableZones,
            title: "Зоны нестабильных координат",
            allow: pathPolicy.canSeeUnstableZones(),
            Component: UnstableZones,
            inAdminSection: true,
        },
        {
            path: paths.regionDryingPeriods,
            title: "Зоны просушек",
            allow: pathPolicy.canSeeRegionDryingPeriods(),
            Component: RegionDryingPeriods,
            inAdminSection: true,
        },
        {
            path: paths.adminReportAllowedUsers,
            title: "Доступ к отчетам",
            allow: pathPolicy.canSeeReportAllowedUsers(),
            Component: ReportAllowedUsers,
            inAdminSection: true,
        },
        {
            path: paths.adminInsolvencyRegistry,
            title: "Реестр надежности контрагентов",
            allow: pathPolicy.canSeeAdminInsolvencyRegistry(),
            Component: AdminInsolvencyRegistry,
            inAdminSection: true,
        },
        {
            path: paths.adminAccessPermits,
            title: "Допуски и разрешения",
            allow: pathPolicy.canSeeAdminAccessPermits(),
            Component: AdminAccessPermits,
            inAdminSection: true,
        },
        {
            path: paths.adminParcelStatuses,
            title: "Статусы отслеживания документов",
            allow: pathPolicy.canSeeAdminParcelStatuses(),
            Component: AdminParcelStatuses,
            inAdminSection: true,
        },
    ];

    if (isDemoPeriodExpired) {
        const isAllowedPath = (path: any) => {
            if (typeof path !== "string") {
                return false;
            }
            return (
                path === paths.root ||
                path.startsWith(paths.profile) ||
                path.startsWith(paths.bid) ||
                path.startsWith(paths.reports) ||
                path.startsWith(paths.finances)
            );
        };

        const disableDisallowed = (items: RouteObj[]) => {
            items.forEach((item) => {
                if (item.items) {
                    disableDisallowed(item.items);
                    if (item.items.every((child) => !child.allow)) {
                        item.allow = false;
                    }
                } else if (!isAllowedPath(item.path)) {
                    item.allow = false;
                }
            });
        };
        disableDisallowed(result);
    }

    return result;
}

function generateRoutes(routesObj: ReturnType<typeof generateRoutesObj>) {
    return Object.values(routesObj)
        .filter((item) => item.allow && (!!item.Component || !!item.items))
        .map(({ path, Component, items }) => ({
            path,
            Component,
            items: items?.filter((item) => item.allow && !!item.Component),
        }));
}

function generateLinks(routesObj: ReturnType<typeof generateRoutesObj>) {
    return Object.values(routesObj)
        .filter((item) => item.allow && item.title)
        .map(({ path, title, inAdminSection, external, iconClassName, items }) => ({
            path,
            title,
            inAdminSection,
            external,
            iconClassName,
            items: (items || []).filter((item) => item.allow),
        }));
}

type StoredRouteModels = ReturnType<typeof generateRoutes>;

export { paths, generateRoutesObj, generateRoutes, generateLinks, StoredRouteModels, RouteObj };
